module.exports = __webpack_public_path__ + "img/DE00249.90ce8b8d.png";